import {ClassName, DefaultChildren} from '#/utils/utils';
import {motion} from 'framer-motion';
import {FunctionComponent} from 'react';

type Themes = 'success' | 'warning' | 'error' | 'notification';

type Props = {
  theme: Themes;
  pxClassName?: `px-${number}`;
  pyClassName?: `py-${number}`;
} & DefaultChildren &
  ClassName;

const NoticeMessageLayout: FunctionComponent<Props> = ({
  children,
  className = '',
  pxClassName = 'px-3',
  pyClassName = 'py-4',
  theme,
}) => {
  const getColorClasses = (theme: Themes) => {
    switch (theme) {
      case 'success':
        return 'border-upgreen bg-upgreen/20 text-upgreen';
      case 'warning':
        return 'border-yellowNotice bg-yellowNotice/20 text-yellowNotice';
      case 'error':
        return 'border-redNotice bg-redNotice/20 text-redNotice';
      case 'notification':
        return 'border-yellowNotice bg-yellowNotice text-grayblue';
    }
  };

  return (
    <motion.div
      initial={{opacity: 0}}
      animate={{opacity: 1}}
      exit={{opacity: 0}}
      transition={{ease: 'easeInOut', duration: 0.2}}
      className={`${getColorClasses(
        theme,
      )} snap-center rounded-xl border-2 overflow-hidden break-words ${pxClassName} ${pyClassName} ${className}`}
    >
      {children}
    </motion.div>
  );
};

export default NoticeMessageLayout;
